function toStringValue(value) {
  if (value === null || typeof value === "undefined") {
    return "";
  }

  return String(value).trim();
}

export const DEFAULT_WHATSAPP_AUTO_REPLY_MESSAGE = "Thanks for getting in touch! This inbox isn't monitored, so we can't reply here. Please contact the venue directly for bookings or enquiries. Reply STOP to unsubscribe from future messages.";

export function normalizeWhatsappCredentialAccount(account = {}, fallbackIndex = 0) {
  const appId = toStringValue(account.appId ?? account.app_id);
  const businessId = toStringValue(account.businessId ?? account.business_id);
  const accessToken = toStringValue(account.accessToken ?? account.access_token);
  const maskedAccessToken = toStringValue(account.maskedAccessToken ?? account.masked_access_token);
  const accountName = toStringValue(account.accountName ?? account.account_name);
  const messagingLimitUsage = account.messaging_limit_usage || {};
  const id = toStringValue(account.id);
  const clientKey = id || `pending-${appId}-${businessId}-${fallbackIndex}`;

  return {
    id,
    clientKey,
    accountName: accountName || `WhatsApp account ${fallbackIndex + 1}`,
    appId,
    businessId,
    accessToken,
    maskedAccessToken,
    messagingLimitTier: toStringValue(account.messaging_limit_tier),
    messagingLimit: account.messaging_limit ?? null,
    messagingLimitRefreshedAt: account.messaging_limit_refreshed_at || null,
    messagingLimitUsage,
    autoReplyEnabled: account.autoReplyEnabled ?? account.auto_reply_enabled ?? true,
    autoReplyMessage: toStringValue(account.autoReplyMessage ?? account.auto_reply_message) || DEFAULT_WHATSAPP_AUTO_REPLY_MESSAGE,
  };
}

export function serializeWhatsappCredentialAccount(account = {}) {
  const id = toStringValue(account.id);

  return {
    ...(id ? { id } : {}),
    account_name: toStringValue(account.accountName),
    app_id: toStringValue(account.appId),
    business_id: toStringValue(account.businessId),
    access_token: toStringValue(account.accessToken),
    auto_reply_enabled: Boolean(account.autoReplyEnabled),
    auto_reply_message: toStringValue(account.autoReplyMessage) || DEFAULT_WHATSAPP_AUTO_REPLY_MESSAGE,
  };
}

export function maskWhatsappAccessToken(accessToken) {
  const token = toStringValue(accessToken);
  if (!token) {
    return "";
  }

  if (token.length <= 8) {
    return "••••••••";
  }

  return `${token.slice(0, 4)}••••${token.slice(-4)}`;
}
